<template>
  <v-tooltip v-if="workflowLimits" :disabled="isMobile" bottom>
    <template v-slot:activator="{ on }">
      <div class="workflow-controls__limits" v-if="workflowLimits" v-on="on">
        <span
          class="workflow-controls__limits-current"
          :class="getColorClass()"
        >
          {{ triggersCount }}
        </span>
        /
        <span class="workflow-controls__limits-max">
          {{ workflowLimits.cap }}
        </span>
      </div>
    </template>
    <span>
      The limit of all lessons and automation for this campaign is
      <strong>{{ workflowLimits.cap }}</strong>
    </span>
  </v-tooltip>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import {
  getCampaignWorkflowSizeCap,
  getCampaignWorkflowTriggerCount,
} from './workflow-helpers';

export default {
  name: 'WorkflowControlsLimit',
  props: {
    rootNodeId: {},
    campaign: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('org', ['usageLimits']),
    ...mapGetters(['triggers']),
    workflowSizeCap() {
      return getCampaignWorkflowSizeCap(this.campaign, this.usageLimits);
    },
    workflowLimits() {
      const cap = this.workflowSizeCap;
      if (!cap) return null;
      return { cap };
    },
    triggersCount() {
      return getCampaignWorkflowTriggerCount(this.triggers);
    },
  },
  methods: {
    getColorClass() {
      if (!this.workflowLimits) return '';

      const base = 'workflow-controls__limits';
      let flag = 'primary';
      const { cap } = this.workflowLimits;

      if (this.triggersCount + 3 >= cap) {
        flag = 'error';
      } else if (this.triggersCount + 6 >= cap) {
        flag = 'warning';
      }

      return `${base}--${flag}`;
    },
  },
};
</script>

<style lang="less">
.workflow-controls__limits {
  display: flex;
  font-weight: bold;
  font-size: 18px;
  margin-top: 8px;
  justify-content: center;
  position: absolute;
  width: 100%;

  span {
    padding: 0 6px;
  }

  &--primary {
    color: var(--v-primary-base);
  }

  &--warning {
    color: var(--v-warning-base);
  }

  &--error {
    color: var(--v-error-base);
  }
}
</style>
